import { HouseholdMigrationErrorMessage } from '@kaltura-ott/tvpil';
import { appStore, ErrorPriority, ToastMessage } from '@kaltura-ott/tvpil-shared';

import { ERROR_ACTION_NAMES } from 'consts';
import routes from 'routesPaths';
import { isDetailsInitError, isLoginFormError, isRecordingTypeError } from 'utils';
import { isNetworkErrorCode } from 'utils/isNetworkErrorCode';

export function resolveError() {
  const errList = appStore.apiError!;
  const toastList = appStore.toastStore.list as ToastMessage[];
  const { onRetry, title, message, code, type, actionName, onCancel, id } =
    Object.values(errList).find((error) => error.actionName === ERROR_ACTION_NAMES.APP_REBOOT) ||
    errList[Object.keys(errList)[0]];
  const isNetworkCode = isNetworkErrorCode(code);
  const isHighType = type === ErrorPriority.high;
  const isMediumType = type === ErrorPriority.medium;
  const isLowType = type === ErrorPriority.low;
  const isLoginError = isLoginFormError(actionName);
  const isDetailsError = isDetailsInitError(actionName) || window.location.pathname.includes(routes.details.commonPath);
  const isRecordingError = isRecordingTypeError(actionName);
  const isMigrationError = message === HouseholdMigrationErrorMessage;
  const isDetailsPageFullScreenError = isMediumType && isNetworkCode && isDetailsError;
  const isFullScreenError =
    (isHighType && !isLoginError) ||
    isDetailsPageFullScreenError ||
    ((isLowType || isMediumType) && !isRecordingError && isNetworkCode && !isDetailsError);
  const isToastError = !isDetailsPageFullScreenError && (isMediumType || isDetailsError || isRecordingError) && !toastList.length;

  return {
    commonError: { code, title, message, actionName, onRetry, onCancel },
    isFullScreenError,
    isMigrationError,
    isToastError,
    id,
  };
}
